import React from 'react';
import PropTypes from 'prop-types';

const HotelPolicies = ({ policies = [] }) => {
  if (policies.length === 0) {
    return null;
  }

  return (
    <>
      {policies.map((policy, index) => (
        <div
          key={index}
          className={index < policies.length - 1 ? 'margin-tb' : 'margin-t'}
        >
          <p
            className="body margin-0-b"
            // eslint-disable-next-line react/no-danger -- policy content sourced from trusted internal API
            dangerouslySetInnerHTML={{ __html: policy.description }}
          />
        </div>
      ))}
    </>
  );
};

HotelPolicies.propTypes = {
  policies: PropTypes.arrayOf(PropTypes.shape({
    description: PropTypes.string.isRequired,
  })),
};

export default HotelPolicies;
